export default function PaymentCancelTooltipIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_74778_185296'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_74778_185296)'>
        <path
          d='M15.8737 15.931L14.1028 17.6892L13.2247 16.8108L14.9828 15.04L13.2247 13.2692L14.1028 12.391L15.8737 14.1492L17.6445 12.391L18.5228 13.2692L16.7647 15.04L18.5228 16.8108L17.6445 17.6892L15.8737 15.931ZM5.00033 17.9167C4.4181 17.9167 3.92533 17.715 3.52199 17.3117C3.11866 16.9083 2.91699 16.4156 2.91699 15.8333V13.4296H5.41699V2.08333H17.0837V10.2804C16.8838 10.2153 16.6797 10.1678 16.4714 10.1379C16.263 10.1079 16.0505 10.0929 15.8337 10.0929V3.33333H6.66699V13.4296H11.1974C11.127 13.6293 11.0714 13.832 11.0307 14.0377C10.9902 14.2433 10.9646 14.4571 10.9539 14.6794H4.16699V15.8333C4.16699 16.0694 4.24685 16.2674 4.40658 16.4271C4.5663 16.5868 4.76421 16.6667 5.00033 16.6667H11.1974C11.2764 16.906 11.3766 17.1285 11.4978 17.3342C11.6191 17.5397 11.7561 17.7339 11.9089 17.9167H5.00033ZM7.66053 7.24354V5.99354H14.8401V7.24354H7.66053ZM7.66053 9.64749V8.3975H14.8401V9.64749H7.66053ZM11.1974 16.6667H4.16699H10.9539H10.9362H11.1974Z'
          fill='#1C1B1F'
        />
      </g>
    </svg>
  );
}
